import React, {useState, useEffect} from "react";

import Images from "../../../media/images";
import { Link } from "react-router-dom";
import api from "../../../api/api";

const KycPayment = () => {

  const [dueAmount, setDueAmount] = useState(0)
  
  // getting current user
  useEffect(() => {
    api
      .get("/users/me/")
      .then((response) => {
        setDueAmount(response.data[0].due_amount);
      })
      .catch((error) => {});
  }, []);
 

  return (
    <div>
      <div className="p-2">
        <div className="mt-0 flex flex-col items-center justify-between gap-2 rounded-lg md:flex-row md:gap-20">
          {/* <a href="../kyc-form.html"> */}
           <Link to ="/kyc-form">
            <div className="bg-primary-blue font-Bree flex items-center justify-between gap-10 rounded-xl py-2 px-5 text-sm font-bold text-white lg:!text-lg">
              <div className="flex items-center justify-between">
                <img src={Images.kyc} className="h-10 rounded-2xl" alt="" />
              </div>
              <p>Please upload your KYC form</p>
            </div>
            </Link>
          {/* </a> */}
          <Link to="client/ledger-details">
            <div className="bg-primary-red flex items-center gap-3 rounded-xl py-2 px-4 sm:px-10">
              <h1 className="font-Bree text-sm font-bold text-white lg:!text-lg">
                Your pending payment is Rs {dueAmount}
              </h1>
              <img src={Images.pay_now} className="h-10 rounded-2xl" alt="" />
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default KycPayment;
